import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import locale from 'dojo/date/locale';
import template from './MonthColumnPlan.html?raw';
import domGeom from 'dojo/dom-geometry';
import dojoDate from 'dojo/date';
import MonthColumn from '../MonthColumn/MonthColumn';
import "../MonthColumn/MonthColumn";
import DayRow from '../DayRow/DayRow';
import "../DayRow/DayRow";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';

class MonthColumnPlan extends compose(_WidgetBaseSP) {
    templateString: any = template;

    monthContainer: HTMLElement;

    _monthRegistry: Array<MdsLax<InstanceType<typeof MonthColumn>>> = [];
    includeYearInTitle: boolean = true;
    editable: boolean = false;
    print: boolean = false;

    quantityMothsToDisplay: number = 2;
    maxMonthsToDisplay: number = 99;


    constructor(args) {
        super(...(arguments as unknown as []));
        this._monthRegistry = [];
    }

    _setEditableAttr(value: boolean): void {
        this.editable = value;
        let months = this.getAllMonths();

        for (let i = 0; i < months.length; i++) {
            let month = months[i];

            month.set("editable", this.editable);
        }
    }

    getAllMonths(): Array<MdsLax<InstanceType<typeof MonthColumn>>> {
        return this._monthRegistry;
    }

    _handleVisibleColumns(data: { event_d: boolean, text_d: boolean, groupNodeWidth: number }): void {

        for (let monthItem of this._monthRegistry) {
            monthItem._handleVisibleColumns(data);
        }

        setTimeout(lang.hitch(this, "adjustCurrentMonthContainerWidth"), 250);

    }

    adjustCurrentMonthContainerWidth(): void {
        let width: number = 0;
        for (let i = 0; i < this._monthRegistry.length; i++) {
            let monthItem: MdsLax<InstanceType<typeof MonthColumn>> = this._monthRegistry[i];

            //	tats�chliche breite der Monatsspalte finden
            // muss graben f�r die types - T'ODO
            let computedStyle = this.UiModder.domStyle.getComputedStyle(monthItem.domNode);
            let mbox = domGeom.getMarginBox(monthItem.domNode, computedStyle);

            width += mbox.w;
        }

        //monthContainer muss genau so breit sein wie die summe aller bereiten seiner child-nodes
        //this.UiModder.domStyle.set(this.monthContainer, "width", width + "px");
    }

    addMonthRange(startDate: Date, maxItems: number): void {
        for (let i = 0; i < maxItems; i++) {

            let currentDate = dojoDate.add(startDate, "month", i);
            this.addMonth(currentDate.getFullYear(), currentDate.getMonth());
        }
    }

    _onMonthColumnHeaderUp(monthItem: MdsLax<InstanceType<typeof MonthColumn>>): void {
        let year: number = monthItem.year;
        let month: number = monthItem.month;
        monthItem._setMonthDate(year, month - 1);
        this.emit("MonthColumn/monthDateChange", monthItem);
    }

    _onMonthColumnHeaderDown(monthItem: MdsLax<InstanceType<typeof MonthColumn>>): void {
        let year: number = monthItem.year;
        let month: number = monthItem.month;
        monthItem._setMonthDate(year, month + 1);
        this.emit("MonthColumn/monthDateChange", monthItem);
    }

    _onMonthColumnHeaderClose(monthItem: MdsLax<InstanceType<typeof MonthColumn>>): void {
        let dlg = new GenericDialog();
        dlg.destroyOnClose = true;
        dlg.setSize('smaller');
        dlg.show(this.translations["MonthColumnPlan__closeMonthConfirmMessage"], this.translations["MonthColumnPlan__closeMonthConfirmMessage"], "", 'far fa-question-circle', 'yesno', lang.hitch(this, (res: any) => {
            if (res == 2) {
                let index = this._monthRegistry.indexOf(monthItem);
                this._monthRegistry.splice(index, 1);
                monthItem.destroy();
                this._onMonthColumnHeaderCloseContinue();
            } else {
                this._onMonthColumnHeaderCloseContinue();
            }
        }));
    }
    _onMonthColumnHeaderCloseContinue() {
        //???
        this._monthRegistry
    }


    _addListenersToMonth(monthItem: MdsLax<InstanceType<typeof MonthColumn>>): void {
        // durchschleifen

        monthItem.on("DayRow/dblClick", lang.hitch(this, function (message: { date: Date, appointment: MCP_appointment, sender: MdsLax<InstanceType<typeof DayRow>> }) {
            this.emit("DayRow/dblClick", message);
        }));
        monthItem.on("DayRow/directValueChanged", lang.hitch(this, function (message: { modifiedAppointment: MCP_currentlyModifiedAppointment, sender: MdsLax<InstanceType<typeof DayRow>> }) {
            this.emit("DayRow/directValueChanged", message);
        }));
        monthItem.on("updateGroupOrder", lang.hitch(this, function (message: { modifiedAppointment: MCP_currentlyModifiedAppointment, sender: MdsLax<InstanceType<typeof DayRow>> }) {
            this.emit("updateGroupOrder", message);
        }));
        monthItem.on("saveButtonState", lang.hitch(this, function (message: { disabled: boolean }) {
            this.emit("saveButtonState", message);
        }));
        monthItem.on("DayRow/dnd_drop", lang.hitch(this, function (message: { dndData: object, sender: MdsLax<InstanceType<typeof DayRow>> }) {
            this.emit("DayRow/dnd_drop", message);
        }));
        monthItem.on("MonthColumn/header/monthUp", lang.hitch(this, "_onMonthColumnHeaderUp"));
        monthItem.on("MonthColumn/header/monthDown", lang.hitch(this, "_onMonthColumnHeaderDown"));
        monthItem.on("MonthColumn/header/monthClose", lang.hitch(this, "_onMonthColumnHeaderClose"));
        monthItem.on("triggerPrint", lang.hitch(this, () => { this.emit("triggerPrint") }));
        monthItem.on("MonthColumn/registerAlternativeColorNameBooking", lang.hitch(this, (ev) => { this.emit("MonthColumn/registerAlternativeColorNameBooking", ev) }));
        monthItem.on("MonthColumn/groupDivClick", lang.hitch(this, function (groupID: string) {

            for (let monthItem of this._monthRegistry) {
                monthItem._onclick_groupDiv(null, groupID);
            }
        }));

        monthItem.on("deleteApointment", lang.hitch(this, (deleteMePls: MCP_currentlyModifiedAppointment) => {
            this.emit("deleteApointment", deleteMePls);
        }));

        monthItem.on("refreshStaticValues", lang.hitch(this, () => {
            this.emit("refreshStaticValues");
        }));
    }

    sortMonths(direction: "ASC" | "DESC"): void {

        if (this._monthRegistry.length) {

            this._monthRegistry.sort(function (a, b) {
                let fa: string = locale.format(a.monthDate, {
                    selector: "date",
                    datePattern: "yyyy-MM-dd"
                });
                let fb: string = locale.format(b.monthDate, {
                    selector: "date",
                    datePattern: "yyyy-MM-dd"
                });

                if (direction == "ASC") {
                    if (fa < fb) {
                        return -1;
                    }
                    if (fa > fb) {
                        return 1;
                    }
                } else {
                    if (fa > fb) {
                        return -1;
                    }
                    if (fa < fb) {
                        return 1;
                    }
                }

                return 0;
            });

            this.UiModder.domAttr.set(this.monthContainer, "innerHTML", null);

            for (let monthItem of this._monthRegistry) {
                monthItem.placeAt(this.monthContainer);
            }

        }
    }

    addMonth(year: number, month: number, forceCreate = false): MdsLax<InstanceType<typeof MonthColumn>> {

        if (this._monthRegistry.length < this.maxMonthsToDisplay) {
            let existingMonth = this.getMonth(year, month);
            if ((!existingMonth) || (forceCreate)) {
                let monthItem = new MonthColumn({
                    year: year,
                    month: month,
                    includeYearInTitle: this.includeYearInTitle,
                    editable: this.editable,
                    print: this.print
                });

                this._addListenersToMonth(monthItem);

                monthItem.placeAt(this.monthContainer);

                if (this._monthRegistry.length == 0) {
                    this.UiModder.domClass.add(monthItem.domNode, "monthColumnFirst");
                }

                this._monthRegistry.push(monthItem);
                return monthItem;
            }
            this.adjustCurrentMonthContainerWidth();
        } else {


            let msg: string = this.translations["MonthColumnPlan__maxMonthMessage"];
            msg = msg.replace("::: maxMonths:::", String(this.maxMonthsToDisplay));
            let dlg = new GenericDialog();
            dlg.destroyOnClose = true;
            dlg.show(msg, "", "", "fas fa-info-circle", 'ok');
            console.warn("Maximum ", this.maxMonthsToDisplay, " monthes allowed");
        }
        return null;
    }

    getMonth(year: number, month: number): MdsLax<InstanceType<typeof MonthColumn>> {
        for (let i = 0; i < this._monthRegistry.length; i++) {
            let monthItem: MdsLax<InstanceType<typeof MonthColumn>> = this._monthRegistry[i];

            if (monthItem.year == year && monthItem.month == month) {
                return monthItem;
            }
        }

        return null;
    }

    getMonthByDayRow(dayRow: MdsLax<InstanceType<typeof DayRow>>): MdsLax<InstanceType<typeof MonthColumn>> {
        for (let monthItem of this._monthRegistry) {
            if (monthItem._dayRegistry.indexOf(dayRow) != -1) return monthItem;
        }
        return null;
    }

    removeAllMonths(): void {
        for (let i = 0; i < this._monthRegistry.length; i++) {
            this._monthRegistry[i].destroy();
        }
        this._monthRegistry = [];
    }

    // wird nur bein move appointment, move group und delete aufgerufen - keine verz�gerung hier
    refreshDraftDataForExistingMonths(months?: Array<MdsLax<InstanceType<typeof MonthColumn>>>): void {

        let monthItemsToRefresh = months ? months : this._monthRegistry;

        for (let monthItem of monthItemsToRefresh) {
            monthItem._refreshDraftData();
        }
    }

    // handle data -------------------------------------------------------START

    _getBookingsList(currentFilterSettings: string): void {

        for (let month of this._monthRegistry) {
            month._getBookingsList(currentFilterSettings);
        }
    }


    public requestStaticBookingColorChange(coloringName: string) {
        for (let month of this._monthRegistry) {
            month.requestStaticBookingColorChange(coloringName);
        }
    }

    private _onHandle_ActivateMinimalMode(toggle: boolean) {
        for (let month of this._monthRegistry) {
            month.emit("useMinimalMode", toggle);
        }
    }
    private _onHandle_MinimalModeToggleEmptyDays(t: boolean) {
        for (let month of this._monthRegistry) {
            month.emit("minimalModeToggleShowEmptyDays", t);
        }
    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.on("useMinimalMode", lang.hitch(this, this._onHandle_ActivateMinimalMode));
        this.on("minimalModeToggleShowEmptyDays", lang.hitch(this, this._onHandle_MinimalModeToggleEmptyDays));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(MonthColumnPlan);

/*
verwendete translations in backend:
MonthColumnPlan_filterPanel_header_searchParams
*/
